import React from "react";

const FilterAllIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g>
        <path
          d="M-1 0C-1 0.55228 -0.55228 1 0 1L21.3333 1C21.8856 1 22.3333 0.55228 22.3333 0C22.3333 -0.55228 21.8856 -1 21.3333 -1L0 -1C-0.55228 -1 -1 -0.55228 -1 0Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 5.29948 7.96615)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M-1 0C-1 0.55228 -0.55228 1 0 1L21.3333 1C21.8856 1 22.3333 0.55228 22.3333 0C22.3333 -0.55228 21.8856 -1 21.3333 -1L0 -1C-0.55228 -1 -1 -0.55228 -1 0Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 5.29948 15.9661)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M-1 0C-1 0.55228 -0.55228 1 0 1L21.3333 1C21.8856 1 22.3333 0.55228 22.3333 0C22.3333 -0.55228 21.8856 -1 21.3333 -1L0 -1C-0.55228 -1 -1 -0.55228 -1 0Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 5.29948 23.9661)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default FilterAllIcon;
